import React from "react";
import { CheckCircle } from "react-feather";
import { Row, Col } from "reactstrap";

const LeadsImportStep1UploadProgress = ({ step, onRemoveFile }) => {
  return (
    <Row
      className="align-items-center justify-content-between my-3"
      style={{
        border: "1px solid #13CE66",
        backgroundColor: "#EFFAF7",
        borderRadius: "10px",
        padding: "0 1.5rem",
        height: "110px",
        margin: "0",
      }}
    >
      <Col xs="auto" className="d-flex align-items-center gap-2 mb-2 mb-md-0">
        <div
          style={{
            fontSize: "20px",
            fontWeight: 500,
            color: "#4F4F50",
          }}
        >
          Uploaded
        </div>
        <CheckCircle color="green" size={20} />
      </Col>

      <Col xs="auto">
        <div
          role="button"
          onClick={onRemoveFile}
          style={{
            fontSize: "15px",
            textDecoration: "underline",
            cursor: "pointer",
          }}
        >
          {step === 2 ? "Edit" : "Delete File"}
        </div>
      </Col>
    </Row>
  );
};

export default LeadsImportStep1UploadProgress;
